_ = require 'underscore'
Alerts = require 'app/scripts/views/lib/alerts'
BusinessClassUpsellView = require 'app/scripts/views/directory/business-class-upsell-view'
Controller = require 'app/scripts/controller'
{ firstPartyPluginsOrg } = require '@trello/config'
Format = require 'app/scripts/lib/markdown/format'
PopOver = require 'app/scripts/views/lib/pop-over'
{ sendPluginScreenEvent, sendPluginUIEvent, sendPluginTrackEvent } = require 'app/scripts/lib/plugins/plugin-behavioral-analytics'
View = require 'app/scripts/views/internal/view'
Util = require 'app/scripts/lib/util'
t = require('app/scripts/views/internal/teacup-with-helpers')('board_power_ups')
{ trackUe } = require '@trello/analytics'

class PluginSuggestionPopOver extends View
  className: 'plugin-suggestion-pop-over'

  events:
    'click .js-enable-power-up': 'enablePowerUp'
    'click .js-open-listing': 'openListing'

  initialize: ({ @board, @card }) ->
    @powerUpEnablementInProgress = false

  enablePowerUp: (e) ->
    Util.stop(e)

    sendPluginUIEvent({
      idPlugin: @model.id
      idBoard: @board.id
      idCard: @card.id
      event:
        action: 'clicked'
        actionSubject: 'button'
        actionSubjectId: 'attachmentGetPowerEnableButton'
        source: 'attachmentGetPowerUpInlineDialog'
    })

    if !@board.canEnableAdditionalPowerUps() && !_.contains(@model.get('tags'), 'promotional')
      PopOver.pushView
        autoPosition: true
        displayType: 'directory-business-class-popover'
        elem: @$(e.target)
        hideHeader: true
        view: new BusinessClassUpsellView({ model: @board })

      sendPluginScreenEvent({
        idPlugin: @model.id
        idBoard: @board.id
        idCard: @card.id
        screenName: 'attachmentsGetPowerUpUpgradeInlineDialog'
      })

      return

    if @board.isPluginEnabled(@model.id)
      PopOver.hide()
      return

    # For third party Power-Ups, send them to the /enable page for data consent flow.
    if @model.get('idOrganizationOwner') != firstPartyPluginsOrg
      PopOver.hide()
      boardView = Controller.getCurrentBoardView()
      boardView.directoryReturnCard = @card
      listingUrl = Controller.getBoardUrl(@board.id, 'power-up', [@model.id, 'enable'])
      Controller.navigate listingUrl, { trigger: true }
      return

    @powerUpEnablementInProgress = true
    @render()
    @board.enablePlugin(@model.id, _.contains(@model.get('tags'), 'promotional'))
      .then =>
        trackUe('card-detail', 'enables', 'Power-Up', '', '', 'enable button', @model.id)
        sendPluginTrackEvent({
          idPlugin: @model.id
          idBoard: @board.id
          idCard: @card.id
          event:
            action: 'added'
            actionSubject: 'powerUp'
            source: 'attachmentGetPowerUpInlineDialog'
            attributes:
              installSource: 'attachmentSuggestion'
        })

        @powerUpEnablementInProgress = false
        PopOver.hide()
      .catch (err) =>
        @powerUpEnablementInProgress = false
        @render()
        @board.disablePlugin(@model.id)
        if Util.isJsonString(err.textStatus) && JSON.parse(err.textStatus).error == 'PLUGIN_NOT_ALLOWED'
          Alerts.show('plugin not allowed', 'error', 'addpluginerror', 4000)
        else
          Alerts.show('could not add plugin', 'error', 'addpluginerror', 2000)

    return

  openListing: (e) ->
    Util.stop(e)

    trackUe('card-detail', 'opens', 'Power-Up directory home page', '', '', 'by clicking the learn more link')
    sendPluginUIEvent({
      idPlugin: @model.id
      idBoard: @board.id
      idCard: @card.id
      event:
        action: 'clicked'
        actionSubject: 'link'
        actionSubjectId: 'attachmentGetPowerLearnMoreLink'
        source: 'attachmentGetPowerUpInlineDialog'
    })
    PopOver.hide()

    boardView = Controller.getCurrentBoardView()
    boardView.directoryReturnCard = @card

    listingUrl = Controller.getBoardUrl(@board.id, 'power-up', [@model.id])
    Controller.navigate listingUrl, { trigger: true }


  render: ->
    { description } = @model.get('listing')
    @$el.html t.render =>
      t.div '.plugin-description-container', =>
        t.div '.markeddown', =>
          t.raw Format.markdownAsHtml(description)
      t.p =>
        if !@powerUpEnablementInProgress
          t.button '.button.primary.js-enable-power-up', =>
            t.format 'enable-power-up'
        else
          t.button '.button.primary', =>
            t.format 'power-up-enablement-in-progress'
      t.p '.secondary-links.quiet', =>
        t.a '.js-open-listing', { href: '#' }, =>
          t.format 'learn-more'
    @

module.exports = PluginSuggestionPopOver
